import { Component, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { PixKeyType } from '../../../models/key-type.enum';

@Component({
	selector: 'app-pix-keys-create-header-menu',
	templateUrl: './header-menu.component.html',
	styleUrls: ['./header-menu.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixKeysCreateHeaderMenuComponent {

	@Output() selectKeyTypeEmitter = new EventEmitter<PixKeyType>();
	public selectedKeyType: PixKeyType = PixKeyType.CPF;

	constructor() {}

	selectKeyType(keyType: PixKeyType) {
		this.selectedKeyType = keyType;
		this.selectKeyTypeEmitter.emit(keyType);
	}

	public get keyType(): typeof PixKeyType {
		return PixKeyType;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/keys/create/header-menu/header-menu.component.ts